import { render } from "./DChangeLanguage.vue?vue&type=template&id=5211c7d8"
import script from "./DChangeLanguage.vue?vue&type=script&lang=js"
export * from "./DChangeLanguage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__